import { useParams } from "@tanstack/react-router";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { tripRecordQuery } from "@/app/Cities/Trips/GraphQL/tripRecordQuery";

export function useTripRecord() {
  const { tripId } = useParams({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/admin/trips/$tripId",
  });
  const { data } = useSuspenseGqlQuery(tripRecordQuery, { id: tripId });

  return data.trip;
}
